import React from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { ImageI } from "../../../types";
import { GetImagesPaginatedResponse } from "../../../api/types";
import Combobox from "../../../componentLibrary/Combobox";
import Button from "../../../componentLibrary/Button";

type PaginationSettingsProps = {
  page: number;
  limit: number;
  images: ImageI[];
  meta: GetImagesPaginatedResponse["meta"];
  setPage: (page: number) => void;
  setLimit: (limit: number) => void;
};
const PaginationSettings = ({
  page,
  limit,
  images,
  meta,
  setPage,
  setLimit,
}: PaginationSettingsProps) => {
  const totalImages = meta?.total;
  const imageCountStart = images.length > 0 ? (page - 1) * limit + 1 : 0;
  const imageCountEnd =
    images.length > 0 ? (page - 1) * limit + images.length : 0;
  return (
    <div className="mb-4 flex flex-row justify-between items-center">
      <p className="text-sm text-gray-600">
        {`Showing ${imageCountStart} to ${imageCountEnd} of ${totalImages} images`}
      </p>
      <div className="flex flex-row gap-2">
        <div className="w-20">
          <Combobox
            value={{ value: limit.toString(), label: limit.toString() }}
            onChange={(option) => setLimit(Number(option.value))}
            options={["5", "10", "15", "20", "25", "30"].map((value) => ({
              value: value,
              label: value,
            }))}
          />
        </div>
        <Button disabled={page === 1} onClick={() => setPage(page - 1)}>
          <ChevronLeftIcon className="w-4 h-4" />
        </Button>
        {page !== 1 && <Button onClick={() => setPage(1)}>1</Button>}
        <Button disabled={true}>{page}</Button>
        {page !== meta?.totalPages && meta?.totalPages > 1 && (
          <Button onClick={() => setPage(meta?.totalPages)}>
            {meta?.totalPages}
          </Button>
        )}
        <Button
          disabled={page === meta?.totalPages || meta?.totalPages <= 1}
          onClick={() => setPage(page + 1)}
        >
          <ChevronRightIcon className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};

export default PaginationSettings;
